export const FILE_UPLOAD_STATUSES = {
  PREPARING: 'preparing',
  REJECTED_FILE_TYPE: 'rejected_file_type',
  ERROR_FILE_SIZE: 'error_file_size',
  REJECTED_MAX_FILES: 'rejected_max_files',
  EXCEPTION_UPLOAD: 'exception_upload',
  ERROR_UPLOAD: 'error_upload',
  DONE: 'done',
};

export const FILE_UPLOAD_DIRNAME = 'end-user-form';
export const FILE_UPLOAD_MAX_SIZE_MB = 2;
export const FILE_UPLOAD_MAX_SIZE_BYTES =  FILE_UPLOAD_MAX_SIZE_MB * 1024 * 1024;

